const SECTION_SELECTOR = '[data-section-id]'

export default () => {
  const selectElement = $('.b-tab-navigation__select_js_price')

  // eslint-disable-next-line func-names
  selectElement.on('change', function () {
    if ($(this).val()) {
      $('.b-doctor-details__item').addClass('b-doctor-details__item_padding-top_none')

      $(SECTION_SELECTOR).hide()
      $(SECTION_SELECTOR)
        .filter(`[data-section-id="${$(this).val()}"]`)
        .addClass('is-filtered')
        .show()
    } else {
      $('.b-doctor-details__item').removeClass('b-doctor-details__item_padding-top_none')
      $(SECTION_SELECTOR)
        .removeClass('is-filtered')
        .show()
    }
  })
}
